import { reactive, toRefs } from "vue"

const state = reactive({
  title: "",
})

export function useNavbar(opts?: { title: string }) {
  if (opts) {
    state.title = opts.title
  }
  return toRefs(state)
}
